import React, { useEffect } from "react";
import { useStrapiConfig } from "hooks/useStrapiConfig";
import { setTenant } from "../../storage";
import LayoutSkeleton from "../Layout/LayoutSkeleton";
import { AppInitializerProps } from "types";

export default function AppInitializer({ children }: AppInitializerProps) {
  const { data: loginPageConfig, isLoading } = useStrapiConfig();

  useEffect(() => {
    if (!loginPageConfig) return;
    if (loginPageConfig.tenant) setTenant(loginPageConfig.tenant);
  }, [loginPageConfig]);

  if (isLoading) return <LayoutSkeleton />;

  return <>{children}</>;
}
